module.exports = __webpack_public_path__ + "media/images/23img-280c10e496a0b24e0b0e7f7d1f2b30f6.jpg";